import _ from 'lodash'


export const withUpdatedItemById = (items = [], item) => {
  if (!items.some(i => i.id === item.id)) {
    items = [...items, item]
  }
  return items.map(i => i.id === item.id ? item : i)
}

export const withoutItemById = (items = [], item) => {
  return items.filter(i => i.id !== item.id)
}

export const getFirstArrayItem = (items = []) => {
  return items.length ? items[0] : undefined
}

export const getVisibleServices = (selectedNames, services) => {
  return services.filter((s) => {
    return selectedNames.length === 0 || selectedNames.includes(s.name)
  })
}

export const getVisibleItemsByName = (selectedNames, items) => {
  return items.filter((i) => {
    return selectedNames.length === 0 || selectedNames.includes(i.name)
  })
}

export const getVisibleItemsByKey = (selections, items, key, options = {}) => {
  const {caseSensitive = true} = options
  return items.filter((i) => {
    if (selections.length === 0) {
      return true
    }
    if (caseSensitive) {
      return selections.includes(i[key])
    }
    return selections.map(s => s.toLowerCase()).includes(i[key].toLowerCase())
  })
}

export const getOrSetActiveService = (serviceId, visibleServices) => {
  let service = visibleServices.find(vs => vs.id === serviceId)
  if (!service && visibleServices.length) {
    return visibleServices[0]
  }
  return service
}

export const getFirstService = (services = [], versionsRequired = true) => {
  if (services.length) {
    if (versionsRequired) {
      services = services.filter(s => s.versions && s.versions.length > 0)
    }
    return services[0]
  }
}

export const getSpecificVersion = (service = {}, id) => {
  const {versions = []} = service
  let match = versions.find(v => v.id === id)
  if (match) {
    return match
  }
}

export const getPublishedVersion = (service = {}) => {
  const {versions = []} = service
  let match = versions.find(v => v.published)
  if (!match && versions.length) {
    return versions[0]
  }
}

export const getPublishedOrFirstVersion = (service, defaultValue) => {
  service = service || {}
  const {versions = []} = service
  let match = versions.find(v => v.published)
  if (match) {
    return match
  }
  if (versions.length) {
    return versions[0]
  }
  return defaultValue
}

export const getFirstVersion = (service = {}) => {
  const {versions = []} = service
  if (versions.length) {
    return versions[0]
  }
}

export const getDefaultOrFirstEnvironment = (version) => {
  const {environments = []} = version
  return environments.find(e => e.name === 'default') || environments.length ? environments[0] : undefined
}

export const getFirstResource = (environment) => {
  const {resources = []} = environment
  return resources.length ? resources[0] : undefined
}

export const getFirstResponse = (resource) => {
  const {responses = []} = resource
  return responses.length ? responses[0] : undefined
}

export const getAmountString = (amount) => {
  const rounded = _.round(amount / 100, 2)
  return rounded === 0 ? '$0.00' : rounded.toString().indexOf('.') < 0 ? `$${rounded}.00` : rounded.toString().split('.')[1].length === 1 ? `$${rounded}0` : `$${rounded}`
}

export const isValidId = (value) => {
  return !!value && /^(?=[a-f\d]{24}$)(\d+[a-f]|[a-f]+\d)/i.test(value)
}



